import React from 'react'
import styled from 'styled-components'
import { titles } from './configs/debt_header_titles.json'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 100px 130px 200px 90px 85px;
  border-top: 1px solid #DDDDDE;
  border-bottom: 1px solid #DDDDDE;
  position: relative;
  padding: 5px 0px;
`
const Title = styled.div`
  font-weight: bold;
  padding: 8px 0;
`

const DebtHeader = () => (
  <Container>
    {titles.map(title => <Title key={title}>{title}</Title>)}
  </Container>
)

export default DebtHeader
